__turbopack_context__.v({
  "dialogBackdrop": "Context-module__8AwKba__dialogBackdrop",
  "dialogBox": "Context-module__8AwKba__dialogBox",
  "dialogIcon": "Context-module__8AwKba__dialogIcon",
  "dialogMessage": "Context-module__8AwKba__dialogMessage",
  "error": "Context-module__8AwKba__error",
  "info": "Context-module__8AwKba__info",
  "success": "Context-module__8AwKba__success",
});
